export default __webpack_public_path__ + "static/media/Scholar's Boots of the Heavens.cb9d4766.jpg";